'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, r) {
    if (null == e) return {};
    var o, t, n = _object_without_properties_loose(e, r);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(t = 0; t < i.length; t++)o = i[t], !(r.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
    }
    return n;
}
function _object_without_properties_loose(e, r) {
    if (null == e) return {};
    var o, t, n = {}, i = Object.keys(e);
    for(t = 0; t < i.length; t++)o = i[t], r.indexOf(o) >= 0 || (n[o] = e[o]);
    return n;
}
const ModalDialogHeader = renderWithRef('ModalDialogHeader', null, (o, t)=>{
    var { children: n } = o;
    return jsx(RenderComp, {
        root: "div",
        forwardedRef: t,
        props: _object_without_properties(o, [
            "children"
        ]),
        classNames: [
            'swan-modal-dialog-header'
        ],
        children: n
    });
});

export { ModalDialogHeader };
